var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64062 7.35685L6.41047 4.63293",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0935 9.95434C2.69743 9.95434 3.187 9.46476 3.187 8.86084C3.187 8.25691 2.69743 7.76733 2.0935 7.76733C1.48958 7.76733 1 8.25691 1 8.86084C1 9.46476 1.48958 9.95434 2.0935 9.95434Z",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8617 14.9649V7.33729C16.8617 7.16871 16.7947 7.00704 16.6755 6.88784C16.5563 6.76863 16.3947 6.70166 16.2261 6.70166H15.4088C15.2403 6.70166 15.0786 6.76863 14.9594 6.88783C14.8402 7.00704 14.7732 7.16871 14.7732 7.33729V16.0772C14.7732 16.2458 14.7062 16.4075 14.587 16.5267C14.4678 16.6459 14.3062 16.7129 14.1376 16.7129H13.3203C13.1518 16.7129 12.9901 16.6459 12.8709 16.5267C12.7517 16.4075 12.6847 16.2458 12.6847 16.0772V10.5154C12.6847 10.3469 12.6177 10.1852 12.4985 10.066C12.3793 9.94679 12.2177 9.87982 12.0491 9.87982H11.2318C11.0633 9.87982 10.9016 9.94679 10.7824 10.066C10.6632 10.1852 10.5962 10.3469 10.5962 10.5154V16.9606C10.5962 17.1292 10.5292 17.2909 10.41 17.4101C10.2908 17.5293 10.1292 17.5963 9.96057 17.5963H9.14333C8.97475 17.5963 8.81308 17.5293 8.69388 17.4101C8.57468 17.2909 8.50771 17.1292 8.50771 16.9606V9.24419C8.50771 9.16071 8.49127 9.07806 8.45933 9.00094C8.42738 8.92382 8.38056 8.85374 8.32154 8.79472C8.26251 8.73569 8.19244 8.68887 8.11532 8.65693C8.0382 8.62498 7.95554 8.60854 7.87207 8.60855H7.05483C6.88625 8.60855 6.72457 8.67551 6.60537 8.79472C6.48616 8.91392 6.41919 9.0756 6.41919 9.24418V16.0772C6.4192 16.1607 6.40276 16.2433 6.37081 16.3205C6.33887 16.3976 6.29205 16.4677 6.23303 16.5267C6.174 16.5857 6.10393 16.6325 6.02681 16.6645C5.94969 16.6964 5.86704 16.7129 5.78356 16.7129H4.96632C4.88285 16.7129 4.8002 16.6964 4.72308 16.6645C4.64596 16.6325 4.57589 16.5857 4.51687 16.5267C4.45784 16.4677 4.41102 16.3976 4.37908 16.3205C4.34713 16.2434 4.33069 16.1607 4.33069 16.0772V12.4223C4.33069 12.3389 4.31425 12.2562 4.28231 12.1791C4.25036 12.102 4.20354 12.0319 4.14452 11.9729C4.0855 11.9139 4.01542 11.867 3.93831 11.8351C3.86119 11.8032 3.77853 11.7867 3.69506 11.7867H2.87782C2.70924 11.7867 2.54756 11.8537 2.42836 11.9729C2.30916 12.0921 2.24219 12.2538 2.24219 12.4223V14.1703",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3595 5.6252L8.3125 4.62793",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 4.62791L15.0585 2.82874",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32397 5.09374C7.9279 5.09374 8.41747 4.60417 8.41747 4.00024C8.41747 3.39632 7.9279 2.90674 7.32397 2.90674C6.72005 2.90674 6.23047 3.39632 6.23047 4.00024C6.23047 4.60417 6.72005 5.09374 7.32397 5.09374Z",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4412 7.26171C12.0451 7.26171 12.5347 6.77213 12.5347 6.16821C12.5347 5.56428 12.0451 5.07471 11.4412 5.07471C10.8372 5.07471 10.3477 5.56428 10.3477 6.16821C10.3477 6.77213 10.8372 7.26171 11.4412 7.26171Z",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.906 3.187C16.5099 3.187 16.9995 2.69743 16.9995 2.0935C16.9995 1.48958 16.5099 1 15.906 1C15.3021 1 14.8125 1.48958 14.8125 2.0935C14.8125 2.69743 15.3021 3.187 15.906 3.187Z",
    stroke: "#D9622A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.6f81c224e0fdc1e2a857bda55bd530ae.svg";
export { ForwardRef as ReactComponent };